export enum Layouts {
  Base = 'base'
}
